// @ts-nocheck
import React, { useEffect } from "react";
import Box from '@mui/material/Box';
import Typography from "@mui/material/Typography";
import SinapTheme from "../styles/SinapTheme";
import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import { Edit as EditIcon } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';
import { TreeViewAreas } from './Componentes/TreeViewAreas'
import CircularProgress from "@mui/material/CircularProgress";
import { DialogContent as ModalContent } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useAreas } from "./State/AreasContext";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { useAuth } from "../Auth/State/AuthContext";


const useStyles = makeStyles(theme => ({
    typography: {
        width: "80%",
        padding: "3%",
        color: SinapTheme.palette.primary.main,
    },
    text: {
        fontsize: '20%'
    },
    subtitle: {
        color: SinapTheme.palette.primary.main,
    }
}))

export const VerAgenda = ({ onClose, area, ...props }) => {
    const { areaData, areaSub, fetchArea, fetchSubgrupos, loading, setLoading } = useAreas()
    const classes = useStyles();
    const matches = useMediaQuery('(max-width:600px)');
    const { user, isLogedIn, hasRole } = useAuth();

    useEffect(() => {
        fetchArea(area);
        fetchSubgrupos(area);

    }, [])


    return (
        <>
            {loading ? <CircularProgress color="secondary" /> :
                <Box>
                    <Grid container spacing={2}>
                        <Grid item xs={10} style={{ borderBottomColor: '#cfcfcf', borderWidth: '3%' }}>
                            <Typography align={'left'} className={classes.typography} variant={matches ? "h5" : "h4"}>
                                {areaData.nombre}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <ModalContent dividers>
                            <Grid item xs={12}>
                                {//alias
                                    areaData.alias[0] === '' ?
                                        <p >
                                            <b>Alias:</b> No exiten alias asociados al area
                                        </p> :
                                        matches ?
                                            <div>
                                                <b >
                                                    Alias:
                                                </b>
                                                {
                                                    areaData.alias.map(alia =>
                                                        <ListItem>
                                                            <ListItemText
                                                                primary={alia}
                                                            />
                                                        </ListItem>,
                                                    )
                                                }
                                            </div>
                                            :
                                            <Grid container spacing={2}>
                                                <Grid item xs={2}>
                                                    <b>
                                                        Alias:
                                                    </b>
                                                </Grid>
                                                <Grid item xs={10}>
                                                    {areaData.alias.map(alia =>
                                                        <ListItem>
                                                            <ListItemText
                                                                primary={alia}
                                                            />
                                                        </ListItem>,
                                                    )
                                                    }
                                                </Grid>
                                            </Grid>
                                }
                                {//oficinas
                                    areaData.oficinas[0] === '' ?
                                        <p >
                                            <b>Oficinas:</b> No exiten oficinas asociados al area
                                        </p> :
                                        matches ?
                                            <div>
                                                <b> Oficinas: </b>
                                                <List>
                                                    {
                                                        areaData.oficinas.map(o =>
                                                            <ListItem>
                                                                <ListItemText
                                                                    primary={o}
                                                                />
                                                            </ListItem>,
                                                        )
                                                    }
                                                </List>
                                            </div>
                                            :
                                            <Grid container spacing={2}>
                                                <Grid item xs={2}>
                                                    <b>
                                                        Oficinas:
                                                    </b>
                                                </Grid>
                                                <Grid item xs={10}>
                                                    {areaData.oficinas.map(o =>
                                                        <ListItem>
                                                            <ListItemText
                                                                primary={o}
                                                            />
                                                        </ListItem>,
                                                    )
                                                    }
                                                </Grid>
                                            </Grid>}
                                {//internos
                                    areaData.internos[0].numero === '' ?
                                        <p >
                                            <b>Internos:</b> No exiten internos asociados al area
                                        </p> :
                                        matches ?
                                            <div>
                                                <b> Internos: </b>
                                                <List>
                                                    {
                                                        areaData.internos.map(interno =>
                                                            <ListItem>
                                                                <ListItemText
                                                                    primary={interno['especificacion'] === '' ? interno['numero'] :
                                                                        interno['numero'] + ' - ' + interno['especificacion']}
                                                                />
                                                            </ListItem>,
                                                        )
                                                    }
                                                </List>
                                            </div>
                                            :
                                            <Grid container spacing={2}>
                                                <Grid item xs={2}>
                                                    <b>
                                                        Internos:
                                                    </b>
                                                </Grid>
                                                <Grid item xs={10}>
                                                    {
                                                        areaData.internos.map(interno =>
                                                            <ListItem>
                                                                <ListItemText
                                                                    primary={interno['especificacion'] === '' ? interno['numero'] :
                                                                        interno['numero'] + ' - ' + interno['especificacion']}
                                                                />
                                                            </ListItem>,
                                                        )
                                                    }
                                                </Grid>
                                            </Grid>}
                            </Grid>
                        </ModalContent>
                    </Grid>
                </Box>
            }
        </>
    )
}